import { createContext, useContext, useMemo } from 'react'
import { useSiteOptions, FALLBACK_SITE_OPTIONS } from '../hooks/useSiteOptions'

const SiteContext = createContext(null)

export function SiteProvider({ children }) {
  const { data: siteOptions, isLoading, error } = useSiteOptions()

  // Derive flat named fields from the normalized siteOptions object.
  // Components may use either siteOptions.contact.phone (legacy) or phone (direct).
  const namedFields = useMemo(() => {
    const opts = siteOptions ?? FALLBACK_SITE_OPTIONS
    return {
      phone:        opts.contact?.phone         || FALLBACK_SITE_OPTIONS.contact.phone,
      whatsapp:     opts.contact?.whatsapp      || FALLBACK_SITE_OPTIONS.contact.whatsapp,
      email:        opts.contact?.email         || FALLBACK_SITE_OPTIONS.contact.email,
      location:     opts.contact?.location      || FALLBACK_SITE_OPTIONS.contact.location,
      workingHours: opts.contact?.working_hours || FALLBACK_SITE_OPTIONS.contact.working_hours,
      socialLinks:  opts.social  ?? FALLBACK_SITE_OPTIONS.social,
      heroContent:  opts.hero    ?? FALLBACK_SITE_OPTIONS.hero,
    }
  }, [siteOptions])

  const value = {
    // Raw nested object — used by existing components via siteOptions?.contact?.phone
    siteOptions: siteOptions ?? FALLBACK_SITE_OPTIONS,
    // Named fields — for new components or destructured usage
    ...namedFields,
    isLoading,
    error,
  }

  return (
    <SiteContext.Provider value={value}>
      {children}
    </SiteContext.Provider>
  )
}

export function useSite() {
  const ctx = useContext(SiteContext)
  if (!ctx) throw new Error('useSite must be used within <SiteProvider>')
  return ctx
}
